(() => {
  function initializeTheme() {
  const menuToggle = document.querySelector('[data-menu-toggle]:not([data-bound])');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    menuToggle.dataset.bound = 'true';
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileNav.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-product-section]:not([data-bound])').forEach((section) => {
    section.dataset.bound = 'true';
    const image = section.querySelector('.product-featured-image');
    const thumbnails = section.querySelectorAll('[data-product-thumb]');
    const variantSelect = section.querySelector('[data-variant-select]');
    const submitButton = section.querySelector('[data-add-to-cart]');
    const submitLabel = section.querySelector('[data-submit-label]');
    const price = section.querySelector('[data-product-price]');

    thumbnails.forEach((button) => {
      button.addEventListener('click', () => {
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = button.dataset.imageUrl;
        image.alt = button.dataset.imageAlt || '';
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option.dataset.available === 'true';
        if (price) {
          price.textContent = option.dataset.price;
          if (option.dataset.comparePrice) {
            const compare = document.createElement('s');
            compare.textContent = option.dataset.comparePrice;
            price.append(compare);
          }
        }
        if (image && option.dataset.imageUrl) {
          image.removeAttribute('srcset');
          image.src = option.dataset.imageUrl;
        }
        if (submitButton) submitButton.disabled = !available;
        if (submitLabel) submitLabel.textContent = available ? 'Add to cart' : 'Sold out';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    }
  });

  const sortSelect = document.querySelector('[data-sort-select]:not([data-bound])');
  if (sortSelect) {
    sortSelect.dataset.bound = 'true';
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }
  document.querySelectorAll('[data-product-recommendations]:not([data-bound])').forEach(async (element) => {
    element.dataset.bound = 'true';
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok) throw new Error(`Recommendations request failed (${response.status})`);
      const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = markup.querySelector('.recommendations-inner');
      if (content) {
        element.replaceChildren(content);
        element.hidden = false;
      }
    } catch (error) {
      console.error('Unable to load product recommendations', error);
    }
  });
  }
  initializeTheme();
  document.addEventListener('shopify:section:load', initializeTheme);
})();
